module.exports = __webpack_public_path__ + "img/logo@3x.8952f90a.png";